import React from 'react';
import { useIntl } from 'react-intl';
import VolumetricModularImg from '../images/volumetric-modular.png';
import css from './Sections.module.css';

function SectionsVolumetricModular() {
  const intl = useIntl();

  return (
    <div className={css.volumetricModular}>
      <div className={css.fixedWidthContainer}>
        <h2>{intl.formatMessage({ id: 'SectionsVolumetricModular.title' })}</h2>
        <div className={css.volumetricModularContent}>
          <div className={css.volumetricModularImg}>
            <img src={VolumetricModularImg} alt="" />
          </div>
          <div className={css.volumetricModularInfo}>
            <p>
              {intl.formatMessage({
                id: 'SectionsVolumetricModular.description',
              })}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionsVolumetricModular;
